__turbopack_context__.v({
  "arrow": "filters-module-scss-module__9-spha__arrow",
  "option": "filters-module-scss-module__9-spha__option",
  "select": "filters-module-scss-module__9-spha__select",
  "selected": "filters-module-scss-module__9-spha__selected",
});
